// frontend/src/components/homepage/artefacts/WebsiteMock.js
//
// Tile 02's artefact: a browser chrome with the address bar showing the
// profile URL and a skeleton of the business site inside. Pure markup + CSS,
// no motion - a literal port of the prototype's `.art-web .browser` block.

import React, { memo } from "react";

export const PROFILE_URL_PREFIX = "leadifyai.biz/profile/";
export const PROFILE_URL_SLUG = "your-business";

function WebsiteMock() {
  return (
    <div className="hl-ft-browser" aria-hidden="true">
      <div className="hl-ft-bar">
        <i />
        <i />
        <i />
        <span>
          {PROFILE_URL_PREFIX}
          <em>{PROFILE_URL_SLUG}</em>
        </span>
      </div>
      <div className="hl-ft-site2">
        <div className="hl-ft-shd">
          <b />
          <i />
          <i />
          <i />
        </div>
        <div className="hl-ft-shero">
          <div className="hl-ft-img" />
          <div className="hl-ft-stx">
            <div className="hl-ft-t" />
            <div className="hl-ft-l" />
            <div className="hl-ft-l hl-ft-l70" />
            <div className="hl-ft-b" />
          </div>
        </div>
      </div>
    </div>
  );
}

export default memo(WebsiteMock);
